import React,{useState} from 'react';
import Swal from 'sweetalert2';
import {Container,Row,Col,Card,CardHeader,CardBody,Button, Modal, ModalHeader, ModalBody, ModalFooter,Form, FormGroup, Label, Input} from 'reactstrap'
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleLeft, faAngleDoubleRight, faAngleLeft, faAngleRight, faEdit, faFilter, faPlus, faTrashAlt,faClipboardCheck } from '@fortawesome/free-solid-svg-icons';
import tema from "../../services/Plantilla";



class Listar extends React.Component {
    constructor(props) {
        super(props);
        
    }


    state = {
        load: '',
        datosCargados: false,
        clientes: [],
        Modulos: [],
        Permisos: []
    }
    borrarRegistros = (id) => {
        Swal.fire({
            title: 'Está seguro de Eliminar el cliente?',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Borrar',
            denyButtonText: `Cancelar`,
        }).then((result) => {
            if (result.isConfirmed) {
                authAxios.get("clientes/delclientes/"+id)
                    .then((datosRespuesta) => {
                        
                        Swal.fire('Borrado!', datosRespuesta.data.msj, 'success')
                        this.ListarClientes(1);
                    })
                    .catch();
            } else if (result.isDenied) {
                Swal.fire('Cancelado', '', 'info')
            }
        })
    };

    ListarClientes(page){
        Swal.showLoading();
        let bname = document.getElementById('bnombre').value;
        if (bname == '') {
            bname = 0;
        }

        let bnumero = document.getElementById('bnumero').value;
        if (bnumero == '') {
            bnumero = 0;
        }
        authAxios.get("clientes/listar/"+bname+"/"+bnumero+"?page=" + page)
            .then((datosRespuesta) => {
                Swal.close();
                
                var status = datosRespuesta.data.status;
               
                
                this.setState({ datosCargados: true, load: '', clientes: datosRespuesta.data.data, pagina: datosRespuesta.data.total, ultimo: datosRespuesta.data.last_page, actual: datosRespuesta.data.current_page });
            })
        .catch();
        //window.location.href = '/'; window.localStorage.clear();
    }
  
    
   
   
    LinkEditar(ide){
        localStorage.setItem('ide', ide);
        
        window.location.href = process.env.PUBLIC_URL+'/clientes/editar/'+tema;
    }

    componentDidMount() {
        this.ListarClientes(1);
      
    }
    render() {
        const { load, roles, pagina, ultimo, actual,clientes ,Permisos,modal} = this.state;
        return (
            
            <div className="content">
             


                <div className="container-fluid">
                    <br />
                    <div className="card">
                        <div className="card-header">
                            <Link className="btn btn-success btn-sm" to={"/clientes/crear/"+tema}><FontAwesomeIcon icon={faPlus} />&nbsp;&nbsp;Nuevo Cliente</Link>
                        </div>
                        <div className="card-body">
                            <h4>Lista de Clientes</h4>
                            <hr />
                            <div className="row">
                                <div className="col-xl-3">
                                    <input style={{textTransform: 'uppercase'}} type="text" id="bnombre" name="bnombre" placeholder="NOMBRE DEL CLIENTE" className="form-control form-control-sm" />
                                </div>
                                <div className="col-xl-3">
                                    <input style={{textTransform: 'uppercase'}} type="text" id="bnumero" name="bnumero" placeholder="CEDULA CLIENTE" className="form-control form-control-sm" />
                                </div>
                                <div className="col-xl-3">
                                    <button id="bt" name="bt" className="btn btn-secondary btn-sm" onClick={() => this.ListarClientes(1)}><FontAwesomeIcon icon={faFilter} />&nbsp;&nbsp;Filtrar</button>
                                </div>
                            </div>
                            <br></br>
                            <div className="row">
                                <table className="table table-hover table-condensed table-sm">
                                    <thead className="thead-inverse">
                                        <tr>
                                            <th className="align-middle">DOCUMENTO</th>
                                            <th className="align-middle">NUMERO</th>
                                            <th className="align-middle">NOMBRE</th>
                                            <th className="align-middle">EMAIL</th>
                                            <th className="align-middle">TELEFONO</th>
                                            <th className="align-middle">CELULAR</th>
                                            <th className="align-middle">OPCIONES</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {load}
                                        {
                                            clientes.map((itemClientes) => (
                                                <tr key={itemClientes.id}>
                                                    <td>{itemClientes.tipo}</td>
                                                    <td>{itemClientes.numero}</td>
                                                    <td>{itemClientes.nombre}</td>
                                                    <td>{itemClientes.email}</td>
                                                    <td>{itemClientes.telefono}</td>
                                                    <td>{itemClientes.celular}</td>
                                                    <td>
                                                        <div className="btn-group" role="group" aria-label="">
                                                            
                                                            <button
                                                                type="button"
                                                                className="btn btn-primary btn-xs"
                                                                onClick={() =>
                                                                    this.LinkEditar(itemClientes.id)
                                                                }
                                                            >
                                                                   <FontAwesomeIcon icon={faEdit} />
                                                            </button>

                                                            <button
                                                                type="button"
                                                                className="btn btn-danger btn-xs"
                                                                onClick={() =>
                                                                    this.borrarRegistros(itemClientes.id)
                                                                }
                                                            >
                                                                <FontAwesomeIcon icon={faTrashAlt} />
                                                            </button>
                                                       
                                                            
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))
                                        }
                                    </tbody>
                                </table>
                            </div>
                            <nav aria-label="Page navigation example">
                                <ul className="pagination">
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarClientes(1)}><FontAwesomeIcon icon={faAngleDoubleLeft} /></a></li>
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarClientes(actual - 1)}><FontAwesomeIcon icon={faAngleLeft} /></a></li>
                                    {(() => {
                                        let p = [];
                                        p.push(<li className="page-item" key={actual}><a className="page-link" href="#" onClick={() => this.BuscarRol(actual)}>{actual}</a></li>);
                                        return p;
                                    })()}
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarClientes(actual + 1)}><FontAwesomeIcon icon={faAngleRight} /></a></li>
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarClientes(ultimo)}><FontAwesomeIcon icon={faAngleDoubleRight} /></a></li>
                                </ul>
                            </nav>
                        </div>
                        <div className="card-footer text-muted">
                            <b>Pagina</b> <span className="badge bg-primary">{actual}</span> <b>de</b> <span className="badge bg-primary">{ultimo}</span> | <b>Registros</b> <span className="badge bg-success">{pagina}</span>
                        </div>
                    </div>
                </div>
                
            </div>
        );
    }
}

export default Listar;